// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import { Breakpoints } from '../utils/breakpoints';

export const SetupSwiper = () => {

  const contentSliders = document.querySelectorAll('.slider');

  contentSliders.forEach((element) => {

    const slidesPerView = element.getAttribute('data-slides-per-view') || 1;

    const config = {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: slidesPerView,
      speed: 1000,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        bulletActiveClass: 'current',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      centeredSlides: true,
      grabCursor: true,
      loop: true,
      navigation: {
        prevEl: element.querySelector('.swiper-button-prev'),
        nextEl: element.querySelector('.swiper-button-next')
      }
    }

    const autoplay = element.getAttribute('data-autoplay-enable')
    const autoplayDelay = element.getAttribute('data-autoplay-delay')
    if (autoplay) {
      config.autoplay = {
        delay: Number(autoplayDelay),
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }

      if (element.getAttribute('data-interaction') == "0") {
        config.autoplay.pauseOnMouseEnter = false
      }
    }

    const spaceBetween = element.getAttribute('data-space-between')
    if (spaceBetween === "") {
      config.spaceBetween = 24 // --tc-gutter-x
    }

    const speed = element.getAttribute('data-speed');
    if (speed) {
      const speedNum = Number(speed);
      if (speed < 0 && autoplay) {
        config.autoplay.reverseDirection = true;
      }
      config.speed = Math.abs(speedNum);
    }

    if (slidesPerView == "auto") {
      config.slidesPerView = "auto";
      const minWidth = element.getAttribute('data-slide-min-width') || 150;
      // calculate the width of each slide
      const slides = element.querySelectorAll('.swiper-slide');
      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        const padding = getComputedStyle(slide).paddingLeft;
        const sizerElement = slide.querySelector('.swiper-auto-width-el')
        if (sizerElement) {
          sizerElement.style.display = 'inline-block';
          const slideWidth = parseInt(minWidth, 10) > sizerElement.offsetWidth ? parseInt(minWidth, 10) : sizerElement.offsetWidth
          slide.style.width = Number(slideWidth + parseInt(padding, 10) * 2) + "px";
          sizerElement.style.display = 'block';
        } else {
          console.warn("No child with class 'swiper-auto-width-el' found in the slider with setting slides-per-view to 'auto'.");
        }
      }
    } else if (slidesPerView > 1) {
      const swiperBreakpoints = calculateSwiperBreakpoints(slidesPerView);
      config.breakpoints = swiperBreakpoints
    }

    new Swiper(element, config)
  });

}

function calculateSwiperBreakpoints(slidesPerView) {
  // this will be returned
  const swiperBreakpoints = {};
  // retrieve all breakpoints, remove the largest (xl)
  const breakpointsService = new Breakpoints();
  const allBreakpoints = breakpointsService.getAll()
  delete allBreakpoints.xl;

  // calculate the step size between each breakpoint, e.g. 8 / 4 = 2 (=> xs: 1, sm: 1+2, md: 1+2+2)
  const perBreakpoint = slidesPerView / (Object.keys(allBreakpoints).length + 1)

  // sort the breakpoints by pixel values for the loop
  const breakpointPixelValues = Object.values(allBreakpoints).sort((a, b) => a - b)

  let i = 0;
  // force add a breakpoint for 0px
  swiperBreakpoints[0] = { slidesPerView: 1 };
  for (const breakpointSize of breakpointPixelValues) {
    i++;
    // calculate how much slides shall be displayed
    const slidesPerBreakpoint = Math.round(1 + i * perBreakpoint)
    // add the config
    swiperBreakpoints[breakpointSize] = { slidesPerView: slidesPerBreakpoint }
  }

  return swiperBreakpoints;
}